import { Card, Flex, rem } from "@mantine/core"
import { useForm } from "@mantine/form"
import { useGetServiceType } from "hooks/useRequest/form"
import { useCreateProject } from "hooks/useRequest/project/projectRequest"
import { useCreateUser } from "hooks/useRequest/user/userRequest"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css'

import IProjectCreate from "rules/interface/project/create.interface"
import abTestService from "services/ab-test.service"
import cityService from "services/city.service"
import LastProjectService from "services/last-project"
import selectedContractorService from "services/selected-contractor.service"
import tokenService from "services/token.service"
import trackProjectSerivce from "services/track-project.serivce"
import visitedPageService from "services/visited-page.service"
import PriceFormStepLocation from "./steps/location"
import PriceFormStepSuccess from "./steps/success"
import PriceFormStepUser from "./steps/user"




const ModelCtaPriceForm = () => {

    const [step, setStep] = useState(1)

    const { query } = useRouter()

    const { mutate: createProjectMutate, isError: createProjectIsError, error: createProjectError, isLoading: createProjectIsLoading, isSuccess: createProjectIsSuccess, data: createProjectData } = useCreateProject()
    const { mutateAsync: createUserMutate, data: createUserData, isError: createUserIsError, error: createUserError, isLoading: createUserIsLoading } = useCreateUser()

    const { data: serviceTypes } = useGetServiceType()

    // convert service name to id
    const convertServiceToId = (service: string) => {
        return serviceTypes?.data?.find(res => res.name === service)?._id
    }

    const form = useForm<IProjectCreate>({
        initialValues: {
            forceVerify: false,
        }
    })

    const stepHandler = (currentStep: number) => {
        switch (currentStep) {
            case 1: return <PriceFormStepLocation form={form} nextStep={() => setStep(step + 1)} />
            case 2: return <PriceFormStepUser form={form} nextStep={onFinish} prevStep={() => setStep(step - 1)} loading={createProjectIsLoading || createUserIsLoading} />
            case 3: return <PriceFormStepSuccess />
            default: return <PriceFormStepLocation form={form} nextStep={() => setStep(step + 1)} /> // retur default form step location
        }
    }

    useEffect(() => {
        if (createProjectIsSuccess) {
            cityService.setCity(form.values.city)

            // set project details
            LastProjectService.setProject({
                id: createProjectData.data._id,
                createdDate: createProjectData.data.createdAt,
                project: createProjectData.data
            })

            tokenService.setUser({
                ...createUserData.data,
                id: createUserData.data?._id,
                projectId: createProjectData?.data._id,
            })

            setStep(step + 1)
        }
    }, [createProjectIsSuccess])

    const onFinish = (values: IProjectCreate) => {
        try {
            createUserMutate({
                ...values.user,
                forceVerify: false,
                province: form.values?.province?._id,
                city: form.values?.city?._id,
            }).then(res => {
                createProjectMutate({
                    user: res.data._id,
                    serviceType: query?.service_type ?? "cabinet",
                    serviceTypeId: convertServiceToId((query?.service_type as string) ?? "cabinet"),
                    location: {
                        province: form.values?.province?._id,
                        city: form.values.city?._id,
                    },
                    sessionId: localStorage.getItem("sessionId"),
                    unstructuredData: query?.unstructured_data,
                    selectedContractors: selectedContractorService.getContractorsId(),
                    ...(abTestService.includesInstallmentUser() && {
                        mightBeInterestedInInstallments: true
                    }),
                    submitInfo: {
                        ...(query?.utm_source && {
                            sourceOfEntry: (query?.utm_source as string),
                        }),
                        formType: query?.utm_campaign ?? query?.form_type ?? "models-details-page-bottom-cta",
                        sourcePage: window.location.href,
                        previousPage: localStorage.getItem("prevPath"),
                        landingPage: visitedPageService.getPages()?.[0]
                    },
                    visitedPages: visitedPageService.getPages(),
                    ...(query?.invitedBy && {
                        invitedBy: query.invitedBy
                    }),
                    ...(query.affId && {
                        affId: query.affId
                    }),
                    trackingData: trackProjectSerivce.get()
                })
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        if (createUserIsError) {
            toast.error(createUserError?.response?.data?.message ?? "ارسال اطلاعات با مشکل مواجه شده است")
        }
    }, [createUserIsError])

    useEffect(() => {
        if (createProjectIsError) {
            toast.error(createProjectError?.response?.data?.message ?? "ارسال اطلاعات با مشکل مواجه شده است")
        }
    }, [createProjectIsError])




    return (
        <Card
            p={rem(24)}
            radius={8}
            w="100%"
            maw={step > 2 ? "unset" : 430}
        >
            <Flex align="end" justify="end" w="100%">
                {
                    stepHandler(step)
                }
            </Flex>
        </Card>
    )
}

export default ModelCtaPriceForm